module.exports = __webpack_public_path__ + "media/steps/raport_icon-f298e7b6.png";